import { render, staticRenderFns } from "./UserTransactionLink.vue?vue&type=template&id=64a06ebf&scoped=true&"
import script from "./UserTransactionLink.vue?vue&type=script&lang=js&"
export * from "./UserTransactionLink.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactionLink.vue?vue&type=style&index=0&id=64a06ebf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a06ebf",
  null
  
)

export default component.exports